import React from "react";

import { TitleM } from "../../../../components/Elements";
import { Container, ContentWrap, SubTitle, CustomTextM } from "./styled";
import { template } from "../../_page";

const Contents = () => {
  const { contents } = template;
  return (
    <Container>
      {contents.dynamicContents.map((content, index) => (
        <ContentWrap key={index}>
          {content?.title && <TitleM talign="left">{content.title}</TitleM>}
          <CustomTextM>
            <span dangerouslySetInnerHTML={{ __html: content.subContents }} />
          </CustomTextM>
        </ContentWrap>
      ))}
    </Container>
  );
};

export default Contents;
